interface UserProfile {
    email?: string;
    emplid?: string;
    legacyid?: string;
    company?: string;
  }
  
  interface UserData {
    profile?: UserProfile;
  }
  
  /**
   *
   * @param {UserData} userData - Data from the PingFed
   * @param {string} ContractorUser - "0" or "1" depending on whether user is contractor or alaska employee.
   * @returns {string | never} - Provides the arctic_id depending on whether user is contractor or alaska employee.
   */
  const arcticIDGenerator = (userData: UserData, ContractorUser: string): any => {
    let email = userData?.profile?.email;
  
    // Contractor
    if (ContractorUser === "1") {
      let PS_ID = userData?.profile?.emplid; //peoplesoftid
  
      // Just for Testing
      // let PS_ID = "1053558"; //peoplesoftid
  
      // retrieval of arctic_id by slicing last 5 digit of PeopleSoftId / emplId
      let arctic_id = PS_ID?.slice(-5); // Arctic Id
  
      // AppInsight Log Information
      // logInformation(
      //   `Arctic Id for contractor ${email} is ${arctic_id} & PS_ID is ${PS_ID}`,
      //   "arcticIdGenerator.tsx",
      //   "arcticIdGenerator.tsx"
      // );
  
      return arctic_id ?? '';
    }
  
  };
  
  export default arcticIDGenerator;
  